<script>
const Mode = {
  colorPicker: 0,
  text: 1,
};

export default {
  props: {
    label: { type: String, required: true, },
    modelValue: { type: String, required: true},
  },

  emits: [
    'update:modelValue',
  ],

  created() {
    if (
      navigator.userAgent.includes("Safari/") || 
      navigator.userAgent.includes("MSIE ")) {
      this.mode = Mode.text;
    }
  },

  data() {
    return {
      key: crypto.randomUUID(),
      mode: Mode.colorPicker,
    };
  },

  computed: {
    color: {
      get() { return this.modelValue; },
      set(value) { this.$emit('update:modelValue', value); }
    },

    buttonIndicatorStyle() {
      return {
        backgroundColor: this.color,
      }
    },

    isColorPickerMode() {
      return this.mode === Mode.colorPicker;
    }
  }
}
</script>

<template>
  <div class="color-picker-container">
    <label 
      :for="`input-${key}`"
      class="d-flex align-items-center justify-content-between"
      :class="color != null ? 'filled' : ''"
    >
      <span>{{ label }}</span>
      <template
        v-if="isColorPickerMode"
      >
        <div 
          class="color-indicator"
          :style="buttonIndicatorStyle"
        />
      </template>
      <template
        v-else
      >
      <div
        class="d-flex align-items-center"
      >
        <input
          :id="`input-${key}-text`"
          class="input alt me-2"
          v-model="color"
          type="text"
        />
        <div 
          class="color-indicator small"
          :style="buttonIndicatorStyle"
        />
      </div>
    </template>
  </label>
    
  <input
    :id="`input-${key}-color`"
    v-model="color"
    type="color"
  />
  </div>
</template>

<style lang="scss" scoped>
label {
  margin: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.375rem;
  padding: 10px;
  font-weight: 500;

  &:hover { 
    background: #00000004;
  }
  
  &:hover, 
  &.filled {
    font-weight: 700;
  }
}

input { 
  display: none;
  &.alt {
    display: block;
  }
}

.color-indicator {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  outline: 3px solid #0004;
  outline-offset: -3px;

  &.small {
    width: 20px;
    height: 20px;
  }
}
</style>